import { Team, TeamRole } from '@pkg/types/team'

export const availableRoles: TeamRole[] = [
  'VIEWER',
  'MEMBER',
  'ADMIN',
  'ADMIN_FREE',
]

export const isAdminRole = (role: TeamRole | undefined) =>
  role === 'ADMIN' || role === 'ADMIN_FREE'

export const isFreeRole = (role: TeamRole | undefined) =>
  role === 'VIEWER' || role === 'ADMIN_FREE'

type TeamVisibilitySettings = Pick<
  Team,
  'isVisibilityEnabled' | 'enabledAdminVisibility'
>

export const isTeamVisibleForRole = (
  team: TeamVisibilitySettings,
  role: TeamRole | undefined,
) =>
  team.isVisibilityEnabled || (isAdminRole(role) && team.enabledAdminVisibility)

export const isTeamVisible = (team: Team) => {
  if (!team) return false

  return isTeamVisibleForRole(team, team.userRole)
}
